module.exports = __webpack_public_path__ + "img/SHIELD.17dae9b4.png";